<template>
  <tk-container
    disableScroll
    class="h-full"
  >
    <!-- 登录页面 -->
    <div
      class="flex flex-col p-15 h-full"
    >
      <!-- 返回 -->
      <div class="flex flex-col justify-between flex-grow px-15">
        <!-- 上 -->
        <div>
          <!-- 问候 -->
          <div
            class="text-24 font-600 line-height-44 color-black mt-15"
          >
            扫码登录
          </div>
          <div
            class="w-100% min-h-300 mt-20 bg-white rounded-15 shadow tk-qrcode flex-center flex-col"
          >
            <div
              class="bg-white rounded-15 overflow-hidden p-15"
              id="download-qr"
            >
              <div class="text-16 text-center mb-5">
                红商学院
              </div>
              <vue-qr
                v-if="url !== 'null'"
                :text="url"
                :logo-src="'/img/wechat.png'"
                :size="300"
                :margin="0"
              />
            </div>
            <div class="text-14 text-gray pb-15">
              请使用微信扫码登录
              <span
                class="text-orange cursor-pointer"
                @click="init"
              > (刷新) </span>
            </div>
          </div>
          <!-- 下载按钮 -->
          <div
            class="mt-25 w-full overflow-hidden rounded-16"
          >
            <van-button
              class="w-full"
              color="linear-gradient(270deg, #FC966E 0%, #F96654 100%)"
              @click="download"
            >
              保存图片
            </van-button>
          </div>
        </div>
        <!-- 下 -->
        <div
          class="items-center justify-center text-12 flex mb-5"
        >
          <div class="ml-6">
            已阅读并同意
            <span
              class="cursor-pointer text-orange"
              @click="$push('/article/protocol')"
            >《用户协议》</span>
            和
            <span
              class="cursor-pointer text-orange"
              @click="$push('/article/protocol')"
            >《隐私政策》</span>
          </div>
        </div>
      </div>
    </div>
  </tk-container>
</template>

<script>
import uuidv1 from 'uuid/v1'
import { Toast } from 'vant'
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr
  },
  data () {
    return {
      url: 'null',
      uid: 'hs-' + uuidv1(),
      timer: null,
    }
  },
  mounted () {
    this.init()
  },
  destroyed () {
    if (!this.timer) { return }
    clearInterval(this.timer)
  },
  methods: {
    async init () {
      this.uid = 'hs-' + uuidv1()
      this.url = `${window.location.origin}/auth/login?state=${this.uid}&type=scan`
      await this.addQrCodeRecord()
      await this.intervalQcodeStatus()
    },
    async addQrCodeRecord () {
      await this.$tkParse.post('/classes/qrCodeRecord', {
        state: this.uid,
        status: '待扫',
        timestamp: new Date().getTime(),
      })
    },
    async intervalQcodeStatus () {
      if (this.timer) { clearInterval(this.timer) }
      this.timer = setInterval(async () => {
        const record = await this.$tkParse.getList('/classes/qrCodeRecord', {
          params: {
            limit: 1,
            where: {
              state: this.uid
            }
          }
        })
        if (!record.length) {
          return
        }
        let result = record[0]
        if (new Date().getTime() - result.timestamp > 1000 * 60 * 5) {
          clearInterval(this.timer)
          this.timer = null
          this.init()
          return
        }
        if (result.status === '成功' && result.user) {
          let { data: user } = await this.$tkParse.post('/wxlogin/scanLogin', { objectId: result.user })
          if (user.status === 'success') {
            clearInterval(this.timer)
            this.timer = null
            this.$store.commit('setSessionToken', user.data.sessionToken)
            this.$store.commit('setUser', user.data)
            Toast.success('扫码成功')
            await this.$tkHelper.sleep(1000)
            this.$back()
          }
        }
      }, 3000)
    },
    async download () {
      let dataUrl = await this.$tkHelper.domToImage('#download-qr')
      await this.$tkHelper.saveImage(dataUrl, 'hsxy.png').catch(e => {
        // 保存失败
        Toast.fail('保存失败')
        throw e
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
